import type { ComponentStyleConfig } from "@chakra-ui/react";

import { inputSizeOverrides } from "../shared-themes";

export const SelectTheme: ComponentStyleConfig = {
  variants: {
    outline: {
      field: {
        pl: 3,
        borderColor: "brand.gray.110",
        _hover: {
          borderColor: "brand.red.110",
        },
        _focusWithin: {
          borderColor: "brand.red.100",
          boxShadow: `0px 0px 0px 1px var(--chakra-colors-brand-red-100)`,
        },
      },
    },
  },
  sizes: inputSizeOverrides,
};
